import ProgressLayout from "../../Layouts/Main/progress";
import { CreateModule } from "../factory";
import navigation from "./navigations";

const DetailedEvaluation = ({ baseUrl }) =>
  CreateModule({ baseUrl, navigation, layout: ProgressLayout });
export default DetailedEvaluation;
